import type { ReactNode } from 'react'

export type TextLedProps = {
  heading?: string
  /** @deprecated Use `heading` instead. Kept for backward compatibility with existing MDX. */
  title?: string
  density?: 'compact' | 'wide'
  children: ReactNode
}

export default function TextLed({ heading, title, density = 'compact', children }: TextLedProps) {
  const displayTitle = heading ?? title
  return (
    <div className="slide-text-led" data-archetype="text-led">
      <div className={`slide-column ${density === 'wide' ? 'slide-column--wide' : 'slide-column--compact'}`}>
        {displayTitle ? <h2 className="slide-title">{displayTitle}</h2> : null}
        {children}
      </div>
    </div>
  )
}
